import React from 'react';
import './PetAnimations.css';

export default function SheepSvg({ size = 120, color, className = '' }) {
  const bodyColor = color || '#F0EEE8';
  const lightColor = color ? lighten(color) : '#FFFFFF';
  const darkColor = color ? darken(color) : '#D0CEC8';
  const faceColor = '#A09088';
  const faceDark = '#706860';

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      fill="none"
      className={`pet-svg pet-idle ${className}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Wool body (cloud-like overlapping circles) */}
      <circle cx="44" cy="68" r="16" fill={bodyColor} />
      <circle cx="60" cy="62" r="18" fill={bodyColor} />
      <circle cx="76" cy="68" r="16" fill={bodyColor} />
      <circle cx="50" cy="78" r="14" fill={bodyColor} />
      <circle cx="70" cy="78" r="14" fill={bodyColor} />
      <circle cx="60" cy="74" r="16" fill={lightColor} />
      {/* Wool highlights */}
      <circle cx="54" cy="60" r="8" fill={lightColor} opacity="0.4" />
      <circle cx="68" cy="62" r="6" fill={lightColor} opacity="0.3" />
      {/* Wool bottom fluff */}
      <circle cx="42" cy="82" r="8" fill={bodyColor} />
      <circle cx="78" cy="82" r="8" fill={bodyColor} />
      {/* Legs (tiny, peeking out) */}
      <rect x="42" y="88" width="6" height="12" rx="3" fill={faceColor} />
      <rect x="52" y="90" width="5" height="10" rx="2.5" fill={faceColor} />
      <rect x="64" y="90" width="5" height="10" rx="2.5" fill={faceColor} />
      <rect x="74" y="88" width="6" height="12" rx="3" fill={faceColor} />
      {/* Hooves */}
      <rect x="42" y="98" width="6" height="3" rx="1.5" fill={faceDark} />
      <rect x="52" y="98" width="5" height="3" rx="1.5" fill={faceDark} />
      <rect x="64" y="98" width="5" height="3" rx="1.5" fill={faceDark} />
      <rect x="74" y="98" width="6" height="3" rx="1.5" fill={faceDark} />
      {/* Head (small face peeking from wool) */}
      <ellipse cx="42" cy="52" rx="14" ry="14" fill={faceColor} />
      {/* Wool on top of head */}
      <circle cx="38" cy="40" r="8" fill={bodyColor} />
      <circle cx="48" cy="38" r="8" fill={bodyColor} />
      <circle cx="43" cy="36" r="7" fill={lightColor} />
      {/* Ears */}
      <ellipse cx="28" cy="48" rx="6" ry="4" fill={faceColor} transform="rotate(-15 28 48)" />
      <ellipse cx="56" cy="46" rx="6" ry="4" fill={faceColor} transform="rotate(15 56 46)" />
      {/* Eyes */}
      <circle cx="36" cy="50" r="3.5" fill="white" />
      <circle cx="48" cy="50" r="3.5" fill="white" />
      <circle cx="37" cy="50" r="2" fill="#2C2419" />
      <circle cx="49" cy="50" r="2" fill="#2C2419" />
      <circle cx="37.5" cy="49" r="0.8" fill="white" />
      <circle cx="49.5" cy="49" r="0.8" fill="white" />
      {/* Nose (pink) */}
      <ellipse cx="42" cy="57" rx="3" ry="2" fill="#E8A0A0" />
      {/* Mouth */}
      <path d="M40 59C41 60 43 60 44 59" stroke={faceDark} strokeWidth="0.7" strokeLinecap="round" fill="none" />
    </svg>
  );
}

function lighten(hex) {
  const r = Math.min(255, parseInt(hex.slice(1, 3), 16) + 40);
  const g = Math.min(255, parseInt(hex.slice(3, 5), 16) + 40);
  const b = Math.min(255, parseInt(hex.slice(5, 7), 16) + 40);
  return `rgb(${r},${g},${b})`;
}

function darken(hex) {
  const r = Math.max(0, parseInt(hex.slice(1, 3), 16) - 30);
  const g = Math.max(0, parseInt(hex.slice(3, 5), 16) - 30);
  const b = Math.max(0, parseInt(hex.slice(5, 7), 16) - 30);
  return `rgb(${r},${g},${b})`;
}
